.indicator {
  box-sizing: content-box;
  width: 16px;
  height: 16px;
  padding: 8px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.dot {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: 2px solid var(--colors-primary-dark);
  border-radius: 50%;
  background: var(--colors-primary-main);
}

.indicator:hover,
.indicator:focus-visible {
  background: var(--colors-grays-ultralight);
}

.indicator:hover .dot,
.indicator:focus-visible .dot {
  background: var(--colors-primary-dark);
}

@media (--reefer-media-tablet-min) {
  .indicator {
    width: 18px;
    height: 18px;
    padding: 10px;
  }
}
